import PServiceContent from 'plant-common/src/services/PServiceContent';
import DependentsForContent from '../../../lessonPlan/components/slides/modal/DependentsForContent.vue';
import { PtModal } from 'plant-common';

export default {
	mixins: [PtModal],
	methods: {
		$addObjectiveToIB(objective) {
			this.contents.objectives.push(objective);
		},
		async importITFromObjective() {
			const objective = await PServiceContent.selectContent({ type: 'objective' });
			if (!objective) return;

			// Check objective doesn't exist
			if (
				this.ibObjectives.length &&
				this.ibObjectives.findIndex(o => o.header.metadata.content_id === objective.header.metadata.content_id) !== -1
			) {
				this.$modal('info', {
					title: 'Can not import objective data',
					message: `The selected objective with custom_id ${objective.header.metadata.custom_id} is already imported`,
					ok: {
						text: 'Accept',
						color: '#2196f3'
					}
				});
				return;
			}

			//Modal for selecting IT
			let interactiveText = null;
			interactiveText = await this.$modal(DependentsForContent, {
				content: objective,
				types: ['interactiveText']
			});
			if (!interactiveText) return;

			this.$addObjectiveToIB(objective);

			return interactiveText;
		}
	}
};
